import { customFetch } from 'utils/customFetch';
import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import { UnexpectedError } from 'utils/errors';
import { SportingSecureParams, TSportingClaim } from 'services/sporting/types';
import { createQueryString } from 'utils/createQueryString';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

type Payload = {
  pageNum: number;
};

export const getProcessedRestarauntClaims = async (
  params: SportingSecureParams<Payload>
): Promise<TSportingClaim[]> => {
  const { payload } = params;

  const endpointURL = getSportingServiceURL(
    `getProcessedRestarauntClaims?${createQueryString(payload)}`
  );

  const headers = createSportingHeaders();

  const response = await customFetch(endpointURL, {
    headers
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }

  return response.json();
};
